module.exports = __webpack_public_path__ + "img/icon-10.ce0ec57b.svg";